<div class="min-h-screen bg-slate-50 p-4 font-sans antialiased text-slate-800">
      <div class="max-w-[1400px] mx-auto space-y-4">

            <div class="bg-white rounded-md shadow-sm border border-slate-200 p-4 flex items-center justify-between">
                  <div>
                        <h2 class="text-sm font-bold text-slate-800 uppercase tracking-tight">User Management</h2>
                        <p class="text-[10px] text-slate-500 uppercase font-medium">Manage system access and
                              organizational identities</p>
                  </div>

                  <button (click)="openModal()"
                        class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1.5 rounded text-xs font-bold transition-all shadow-sm flex items-center gap-1.5 uppercase">
                        <span class="text-sm">+</span> New User
                  </button>
            </div>

            <div class="bg-white rounded-md shadow-sm border border-slate-200 overflow-hidden">
                  <div class="overflow-x-auto">
                        <table class="w-full text-left border-collapse">
                              <thead>
                                    <tr
                                          class="bg-slate-50 border-b border-slate-200 text-[10px] uppercase tracking-widest text-slate-500 font-bold">
                                          <th class="px-6 py-3">User Details</th>
                                          <th class="px-6 py-3">Employee ID</th>
                                          <th class="px-6 py-3">Organization</th>
                                          <th class="px-6 py-3">Contact Info</th>
                                          <th class="px-6 py-3">Security</th>
                                          <th class="px-6 py-3 text-right">Actions</th>
                                    </tr>
                              </thead>
                              <tbody class="divide-y divide-slate-100">
                                    <tr *ngFor="let user of users" class="hover:bg-blue-50/30 transition-colors group">

                                          <td class="px-6 py-3">
                                                <div class="text-xs font-bold text-slate-700">{{ user.userName }}</div>
                                                <div
                                                      class="text-[10px] font-medium text-blue-600 uppercase tracking-tighter">
                                                      {{ user.roleName || 'Standard User' }}
                                                </div>
                                          </td>

                                          <td class="px-6 py-3">
                                                <span
                                                      class="font-mono text-[11px] text-slate-500 bg-slate-100 px-1.5 py-0.5 rounded border border-slate-200">
                                                      {{ user.employeeId }}
                                                </span>
                                          </td>

                                          <td class="px-6 py-3">
                                                <div class="text-xs text-slate-600 font-semibold uppercase">{{
                                                      user.orgName || 'Global' }}</div>
                                          </td>

                                          <td class="px-6 py-3">
                                                <div class="text-[11px] text-slate-500">{{ user.email }}</div>
                                                <div class="text-[10px] text-slate-400">{{ user.mobileNumber }}</div>
                                          </td>
                                          <td class="px-6 py-3">
                                                <span [class]="user.twofaEnabled ? 'bg-blue-100 text-blue-700 border-blue-200' : 'bg-slate-100 text-slate-400 border-slate-200'"
                                                      class="text-[9px] font-black px-2 py-0.5 rounded border uppercase tracking-tighter">
                                                      2FA: {{ user.twofaEnabled ? 'Active' : 'Off' }}
                                                </span>
                                          </td>


                                          <td class="px-6 py-3 text-right">
                                                <div class="flex justify-end gap-2 transition-opacity">

                                                      <button (click)="editUser(user)"
                                                            class="p-1.5 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded transition-all">
                                                            <svg class="w-4 h-4" fill="none" stroke="currentColor"
                                                                  viewBox="0 0 24 24">
                                                                  <path d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                                                                        stroke-width="2" />
                                                            </svg>
                                                      </button>

                                                      <button (click)="deleteUser(user.id!)"
                                                            class="p-1.5 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded transition-all">
                                                            <svg class="w-4 h-4" fill="none" stroke="currentColor"
                                                                  viewBox="0 0 24 24">
                                                                  <path d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                                                        stroke-width="2" />
                                                            </svg>
                                                      </button>

                                                </div>
                                          </td>
                                    </tr>

                                    <tr *ngIf="users?.length === 0">
                                          <td colspan="5" class="px-6 py-10 text-center text-slate-400 text-xs italic">
                                                No user records found in the current context.
                                          </td>
                                    </tr>
                              </tbody>
                        </table>
                  </div>


            </div>
      </div>
</div>

<!-- <div *ngIf="isModalOpen"
      class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 backdrop-blur-sm p-4">
      <div class="bg-white w-full max-w-md rounded-lg shadow-2xl border border-slate-200 overflow-hidden">

            <div class="p-4 border-b border-slate-100 flex justify-between items-center bg-slate-50">
                  <h3 class="text-xs font-bold uppercase tracking-widest text-slate-600">{{ isEdit ? 'Modify' :
                        'Register' }} User Account</h3>
                  <button (click)="closeModal()" class="text-slate-400 hover:text-slate-600 text-2xl">&times;</button>
            </div>

            <form [formGroup]="userForm" (ngSubmit)="submit()" class="p-6 space-y-4">
                  <div class="grid grid-cols-2 gap-4">
                        <div>
                              <label class="block text-[10px] font-bold text-slate-500 uppercase mb-1">User Name</label>
                              <input formControlName="userName" type="text" placeholder="Full name"
                                    class="w-full px-3 py-2 border border-slate-200 rounded text-sm outline-none focus:border-blue-500 transition-all">
                        </div>
                        <div>
                              <label class="block text-[10px] font-bold text-slate-500 uppercase mb-1">Employee
                                    ID</label>
                              <input formControlName="employeeId" type="text" placeholder="ID-000"
                                    class="w-full px-3 py-2 border border-slate-200 rounded font-mono text-xs outline-none focus:border-blue-500 transition-all">
                        </div>
                  </div>

                  <div>
                        <label class="block text-[10px] font-bold text-slate-500 uppercase mb-1">Organization
                              Context</label>
                        <select formControlName="orgId" (change)="onOrgChange()"
                              class="w-full px-3 py-2 border border-slate-200 rounded text-sm bg-white outline-none focus:border-blue-500 cursor-pointer">
                              <option [value]="null">Select Organization...</option>
                              <option *ngFor="let org of allOrgs" [value]="org.id">{{ org.name }}</option>
                        </select>
                  </div>
                  <div *ngIf="!isEdit">
                        <label class="block text-[10px] font-bold text-slate-500 uppercase mb-1">Account
                              Password</label>
                        <input formControlName="password" type="password" placeholder="••••••••"
                              class="w-full px-3 py-2 border border-slate-200 rounded text-sm outline-none focus:border-blue-500 transition-all">
                  </div>
                  <div class="flex items-center gap-3 p-2 bg-slate-50 rounded border border-slate-100">
                        <input type="checkbox" formControlName="twofaEnabled" id="twofa"
                              class="w-4 h-4 text-blue-600 border-slate-300 rounded focus:ring-blue-500 cursor-pointer">
                        <label for="twofa" class="text-[10px] font-bold text-slate-600 uppercase cursor-pointer">
                              Enable Two-Factor Authentication (2FA)
                        </label>
                  </div>

                  <div>
                        <label class="block text-[10px] font-bold text-slate-500 uppercase mb-1">System Role</label>
                        <select formControlName="role" [attr.disabled]="filteredRoles.length === 0 ? true : null"
                              class="w-full px-3 py-2 border border-slate-200 rounded text-sm bg-white outline-none focus:border-blue-500 cursor-pointer disabled:bg-slate-50">
                              <option [value]="null">{{ filteredRoles.length ? 'Select Role...' : 'Pick an Org First' }}
                              </option>
                              <option *ngFor="let role of filteredRoles" [value]="role.id">{{ role.name }}</option>
                        </select>
                  </div>

                  <div class="grid grid-cols-2 gap-4">
                        <div>
                              <label class="block text-[10px] font-bold text-slate-500 uppercase mb-1">Email</label>
                              <input formControlName="email" type="email"
                                    class="w-full px-3 py-2 border border-slate-200 rounded text-sm outline-none focus:border-blue-500">
                        </div>
                        <div>
                              <label class="block text-[10px] font-bold text-slate-500 uppercase mb-1">Mobile</label>
                              <input formControlName="mobileNumber" type="text"
                                    class="w-full px-3 py-2 border border-slate-200 rounded text-sm outline-none focus:border-blue-500">
                        </div>
                  </div>

                  <div class="pt-4 border-t border-slate-100 flex justify-end gap-2">
                        <button type="button" (click)="closeModal()"
                              class="px-4 py-2 text-[10px] font-bold text-slate-500 uppercase hover:text-slate-700 transition-colors">Cancel</button>
                        <button type="submit" [disabled]="userForm.invalid"
                              class="bg-blue-600 text-white px-6 py-2 rounded text-[10px] font-bold uppercase shadow-sm hover:bg-blue-700 disabled:opacity-50 transition-all">
                              {{ isEdit ? 'Update' : 'Save' }} User
                        </button>
                  </div>
            </form>
      </div>
</div> -->
<div *ngIf="isModalOpen"
      class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 backdrop-blur-sm p-4">
      <div class="bg-white w-full max-w-3xl rounded-lg shadow-2xl border border-slate-200 overflow-hidden">

            <div class="px-6 py-4 border-b border-slate-100 flex justify-between items-center bg-slate-50/80">
                  <div>
                        <h3 class="text-xs font-bold uppercase tracking-widest text-slate-700">
                              {{ isEdit ? 'Update' : 'Create' }} User Account
                        </h3>
                        <p class="text-[9px] text-slate-400 uppercase font-medium mt-0.5">System Identity & Access
                              Control</p>
                  </div>
                  <button (click)="closeModal()"
                        class="text-slate-300 hover:text-red-500 transition-colors text-2xl leading-none">&times;</button>
            </div>

            <form [formGroup]="userForm" (ngSubmit)="submit()" class="p-6 space-y-6">

                  <div class="grid grid-cols-3 gap-5">
                        <div>
                              <label class="block text-[10px] font-bold text-slate-500 uppercase mb-1 tracking-tight">User
                                    Name</label>
                              <input formControlName="userName" type="text" placeholder="Full Name"
                                    class="w-full px-3 py-2 border border-slate-200 rounded text-sm outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-100 transition-all">
                        </div>
                        <div>
                              <label class="block text-[10px] font-bold text-slate-500 uppercase mb-1 tracking-tight">Employee
                                    ID</label>
                              <input formControlName="employeeId" type="text" placeholder="EMP-000"
                                    class="w-full px-3 py-2 border border-slate-200 rounded font-mono text-xs outline-none focus:border-blue-500 bg-slate-50/30">
                        </div>
                        <div>
                              <label
                                    class="block text-[10px] font-bold text-slate-500 uppercase mb-1 tracking-tight">Organization</label>
                              <select formControlName="orgId" (change)="onOrgChange()"
                                    class="w-full px-3 py-2 border border-slate-200 rounded text-sm bg-white outline-none focus:border-blue-500 cursor-pointer">
                                    <option [value]="null">Select Org...</option>
                                    <option *ngFor="let org of allOrgs" [value]="org.id">{{ org.name }}</option>
                              </select>
                        </div>
                  </div>

                  <div class="grid grid-cols-3 gap-5">
                        <div>
                              <label class="block text-[10px] font-bold text-slate-500 uppercase mb-1 tracking-tight">Email
                                    Address</label>
                              <input formControlName="email" type="email" placeholder="mail@erp.com"
                                    class="w-full px-3 py-2 border border-slate-200 rounded text-sm outline-none focus:border-blue-500">
                        </div>
                        <div>
                              <label class="block text-[10px] font-bold text-slate-500 uppercase mb-1 tracking-tight">Mobile
                                    No.</label>
                              <input formControlName="mobileNumber" type="text" placeholder="+00 000000"
                                    class="w-full px-3 py-2 border border-slate-200 rounded text-sm outline-none focus:border-blue-500">
                        </div>
                        <div>
                              <label class="block text-[10px] font-bold text-slate-500 uppercase mb-1 tracking-tight">System
                                    Role</label>
                              <select formControlName="role" [attr.disabled]="filteredRoles.length === 0 ? true : null"
                                    class="w-full px-3 py-2 border border-slate-200 rounded text-sm bg-white outline-none focus:border-blue-500 cursor-pointer disabled:bg-slate-50">
                                    <option [value]="null">{{ filteredRoles.length ? 'Select Role...' : 'Select Org
                                          First' }}</option>
                                    <option *ngFor="let role of filteredRoles" [value]="role.id">{{ role.name }}
                                    </option>
                              </select>
                        </div>
                  </div>

                  <div class="grid grid-cols-3 gap-5 items-end">
                        <!-- <div [class.opacity-40]="isEdit">
                              <label class="block text-[10px] font-bold text-slate-500 uppercase mb-1 tracking-tight">
                                    {{ isEdit ? 'Password (Fixed)' : 'Account Password' }}
                              </label>
                              <input formControlName="password" type="password" [readonly]="isEdit"
                                    placeholder="••••••••"
                                    class="w-full px-3 py-2 border border-slate-200 rounded text-sm outline-none focus:border-blue-500">
                        </div> -->
                        <div *ngIf="!isEdit">
                              <label class="block text-[10px] font-bold text-slate-500 uppercase mb-1">Account
                                    Password</label>
                              <input formControlName="password" type="password" placeholder="••••••••"
                                    class="w-full px-3 py-2 border border-slate-200 rounded text-sm outline-none focus:border-blue-500 transition-all">
                        </div>
                        <div class="flex items-center gap-3 p-2 bg-slate-50 rounded border border-slate-100">
                              <input type="checkbox" formControlName="twofaEnabled" id="twofa"
                                    class="w-4 h-4 text-blue-600 border-slate-300 rounded focus:ring-blue-500 cursor-pointer">
                              <label for="twofa" class="text-[10px] font-bold text-slate-600 uppercase cursor-pointer">
                                    Enable Two-Factor Authentication (2FA)
                              </label>
                        </div>
                  </div>

                  <div class="pt-6 border-t border-slate-100 flex justify-end items-center gap-4">
                        <button type="button" (click)="closeModal()"
                              class="text-[10px] font-bold text-slate-400 uppercase hover:text-slate-600 transition-colors tracking-widest">
                              Cancel
                        </button>
                        <button type="submit" [disabled]="userForm.invalid"
                              class="bg-blue-600 text-white px-10 py-2.5 rounded text-[10px] font-bold uppercase shadow-md hover:bg-blue-700 disabled:opacity-50 transition-all transform active:scale-95">
                              {{ isEdit ? 'Update' : 'Save' }} User Identity
                        </button>
                  </div>
            </form>
      </div>
</div>